export enum UsersSubTab {
  External = 'external',
  Internal = 'internal',
  Invitations = 'invitations',
}

export const USERS_SUB_TAB_KEYS = [
  UsersSubTab.Internal,
  UsersSubTab.External,
  UsersSubTab.Invitations,
] as const;
